import { RootState, useAppDispatch, useAppSelector } from '@/lib/redux/store';
import React from 'react';
import { removeToast } from './store/toastSlice';
import ToastMessage from './ToastMessage';
import { ToastConfig } from './types';

const ToastContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const toasts = useAppSelector((state: RootState) => state.toast.toasts);

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="toast toast-center toast-top z-50 w-full max-w-md">
      {toasts.map((toast: ToastConfig) => (
        <ToastMessage
          key={toast.id}
          alertType={toast.alertType}
          content={toast.content}
          duration={toast.duration}
          isManualDismiss={toast.isManualDismiss}
          onClose={() => dispatch(removeToast(toast.id))}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
